import { type PaletteOptions, colors } from '@mui/material';

export const palette: PaletteOptions = {
  mode: 'light',
  action: {
    active: colors.blueGrey[600],
  },
  primary: {
    main: '#6692cd',
  },
  secondary: {
    main: '#237fd5',
  },
  text: {
    disabled: 'rgba(0, 0, 0, 0.38)',
    primary: '#333',
    secondary: '#797979',
  },
  background: {
    default: '#f2f3f9',
  },
  warning: {
    main: '#e2760a',
  },
};
